import React from "react";
import { controllers } from "../Controllers/Controllers";
// import { dictionary } from "../Controllers/Dictionaries";
import { navigator } from "../Controllers/Navigator";
import { seo } from "../Controllers/SeoController";

class AppStateController extends React.Component {
    
    mounted: boolean = false

    componentDidMount(){
        if(this.mounted){
            return
        }
        this.mounted = true
        let urlPath = window.location.pathname;
        if (urlPath !== "" && urlPath !== "/") {
            setTimeout(controllers().load.hide, 550);
        } else {
            // console.log("The URL path is empty.");
            setTimeout(controllers().load.hide, 550);
        }
        window.addEventListener('resize', controllers().media.reinit);
        window.addEventListener('scroll', controllers().media.scroll);
        navigator().menuViewingControl()
        controllers().simpleAuth.google.configure()
        AppStateController.restoreData()
    }

    componentWillUnmount(){
        window.removeEventListener('resize', controllers().media.reinit);
    }

    static async restoreData(){
        controllers().auth.restoreMe()
    }


    
    render(){
        return null
    }
}

// @ts-ignore
export {AppStateController};